// components/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import './sub.css';

const NotFound = () => {
  return (
<>
    <section className="about-hero">
        <div className="hero-content1">
          <h1>404 Page Not Found</h1>
        </div>
      </section>
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          Oops! The page you're looking for doesn't exist. It might have been moved or deleted.
        </p>
        <div className="error-actions">
          <Link to="/" className="home-btn">
            Go Back Home
          </Link>
          <Link to="/blog" className="blog-btn">
            Visit Our Blog
          </Link>
        </div>
        <div className="error-suggestions">
          <h3>You might be looking for:</h3>
          <ul>
            <li><Link to="/">Home Page</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
      </div>
    </div>
    </>
  );
};

export default NotFound;